import React, { useContext, useState, useEffect, useRef } from "react";
import webinarContext from "../context/webinarContext";
import "../assets/css/SingleEvent.css";
import { Icon } from "@iconify/react";
import { useParams, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha";

function SingleEvent(props) {
  const context = useContext(webinarContext);
  const host = process.env.REACT_APP_HOST;
  const hiddenFileInput = useRef(null);
  const recaptchaRef = useRef();
  const { webinars } = context;
  const { event } = useParams();
  const selectedwebinar = webinars.filter((webinar) => {
    return webinar.heading === event;
  });
  const remainingWebinar = webinars.filter((webinar) => {
    return webinar.heading !== event;
  });
  const [registration, setregistration] = useState({
    fname: "",
    lname: "",
    email: "",
    mobile: "",
    role: "na",
    company: "na",
    linkedin: "na",
    webinarid: "",
    featphoto: "",
    link: "",
    date: "",
    time: "",
  });
  const onChange = (e) => {
    setregistration({ ...registration, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setregistration({
      ...registration,
      webinarid: selectedwebinar[0].id,
      featphoto: selectedwebinar[0].bannerimage,
      link: selectedwebinar[0].link,
      date: selectedwebinar[0].date,
      time: selectedwebinar[0].time,
    });
  }, []);

  const maxLengthCheck = (e) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const recaptchaValue = recaptchaRef.current.getValue();
    const pattern =
      /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,20}[\.][a-z]{2,5}/g;
    const result = pattern.test(registration.email);
    setregistration({
      ...registration,
      webinarid: selectedwebinar[0].id,
      featphoto: selectedwebinar[0].bannerimage,
      link: selectedwebinar[0].link,
      date: selectedwebinar[0].date,
      time: selectedwebinar[0].time,
    });
    if (
      registration.fname === "" ||
      registration.lname === "" ||
      registration.email === "" ||
      registration.role === "" ||
      registration.company === ""
    ) {
      toast.error("Please Fill Up All the Required Fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    } else if (recaptchaValue === "") {
      toast.error("Invalid Captcha", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    } else {
      props.setloader(true);
      const response = await fetch(`${host}/api/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fname: registration.fname,
          lname: registration.lname,
          email: registration.email,
          mobile: registration.mobile,
          role: registration.role,
          company: registration.company,
          linkedin: registration.linkedin,
          webinarid: registration.webinarid,
          featphoto: registration.featphoto,
          link: registration.link,
          date: registration.date,
          time: registration.time,
        }),
      });
      const json = await response.json();
      console.log(json);
      if (json.success) {
        setregistration({
          fname: "",
          lname: "",
          email: "",
          mobile: "",
          role: "",
          company: "",
          linkedin: "",
          webinarid: "",
          featphoto: "",
          link: "",
          date: "",
          time: "",
        });
        props.setloader(false);
        toast.success(
          "Registered Successfully. Invitaion Link has been sent to your email id",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          }
        );
      } else {
        props.setloader(false);
        toast.error("There was some error while registering you", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <section className="text-gray-600 body-font">
        <div className="container mx-auto flex flex-col px-5 py-24 justify-center items-center">
          <div className="w-full md:w-2/3 flex flex-col mb-16 items-center text-center">
            {/* <p className="text-md my-2 font-semibold text-088AB2 w-full">{ selectedwebinar[0].date } { selectedwebinar[0].time }</p> */}
            <p className="text-md my-2 font-semibold text-088AB2 w-full">
              Cordially invite you for the
            </p>
            <h1 className="title-font text-3xl md:text-5xl mb-4 font-semibold text-101828">
              {selectedwebinar[0].heading}
            </h1>
            <p className="leading-relaxed text-lg text-667085">on</p>
          </div>
          <img
            className={`w-11/12 mb-10 object-center rounded feat-box-shadow ${
              selectedwebinar[0].done ? "hidden" : ""
            }`}
            alt="hero"
            src={require("../assets/images/" +
              selectedwebinar[0].bannerimage +
              ".png")}
          />
          <div
            className={`w-11/12 mb-10 rounded ${
              !selectedwebinar[0].done ? "hidden" : ""
            }`}
          >
            <iframe
              width="80%"
              height="400"
              className="mx-auto"
              src={selectedwebinar[0].video}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div className="w-full md:w-4/5 flex flex-col my-8 items-center text-center">
            <h3 className="text-black font-bold text-2xl">
              Mr. Jagesh Khaitan
            </h3>
            <p className="leading-relaxed text-lg text-667085">
              Chairman, Spandan Foundation for Human Values, will Preside
              <br />
              <br />
              {selectedwebinar[0].host}
            </p>
          </div>
          <hr className="my-5" />
          <div
            className={`container px-5 pt-10 pb-24 mx-auto flex ${
              selectedwebinar[0].done ? "hidden" : ""
            }`}
          >
            <form
              method="POST"
              onSubmit={handleSubmit}
              className="lg:w-4/5 md:w-1/2 md:p-8 p-0 flex flex-col md:mx-auto w-full mt-10 md:mt-0 relative z-10 border-b-2"
            >
              <h2 className=" text-gray-900 text-2xl mb-5 font-semibold title-font">
                Register Now
              </h2>
              <div className="relative my-4 md:pb-8 pb-0">
                <div className="md:w-4/12 w-full inline-block mb-2 md:mb-0">
                  <label
                    htmlFor="name"
                    className="leading-7 font-medium text-md text-344054"
                  >
                    Name<span className="text-D92D20">*</span>
                  </label>
                </div>
                <div className="md:w-4/12 w-1/2 inline-block pr-5">
                  <input
                    type="text"
                    id="fname"
                    name="fname"
                    placeholder="First Name"
                    onChange={onChange}
                    value={registration.fname}
                    className="w-full bg-white rounded-xl border border-D0D5DD text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
                <div className="md:w-4/12 w-1/2 inline-block">
                  <input
                    type="text"
                    id="lname"
                    name="lname"
                    placeholder="Last Name"
                    onChange={onChange}
                    value={registration.lname}
                    className="w-full bg-white rounded-xl border border-D0D5DD text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div className="relative my-4 md:pb-8 pb-0">
                <div className="md:w-4/12 w-full inline-block mb-2 md:mb-0">
                  <label
                    htmlFor="email"
                    className="leading-7 font-medium text-md text-344054"
                  >
                    Email address<span className="text-D92D20">*</span>
                  </label>
                </div>
                <div className="md:w-8/12 w-full inline-block">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="email@gmail.com"
                    onChange={onChange}
                    value={registration.email}
                    className="w-full bg-white rounded-xl border border-D0D5DD text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div className="relative my-4 md:pb-8 pb-0">
                <div className="md:w-4/12 w-full inline-block mb-2 md:mb-0">
                  <label
                    htmlFor="mobile"
                    className="leading-7 font-medium text-md text-344054"
                  >
                    Phone number
                  </label>
                </div>
                <div className="md:w-8/12 w-full inline-block">
                  <input
                    type="number"
                    id="mobile"
                    name="mobile"
                    maxLength={10}
                    onInput={maxLengthCheck}
                    placeholder="9856375836"
                    onChange={onChange}
                    value={registration.mobile}
                    className="w-full bg-white rounded-xl border border-D0D5DD text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div className="relative my-4 pb-8 hidden">
                <div className="md:w-4/12 w-full inline-block mb-2 md:mb-0">
                  <label
                    htmlFor="role"
                    className="leading-7 font-medium text-md text-344054"
                  >
                    Role<span className="text-D92D20">*</span>
                  </label>
                </div>
                <div className="md:w-8/12 w-full inline-block">
                  <input
                    type="text"
                    id="role"
                    name="role"
                    placeholder="Product Designer"
                    onChange={onChange}
                    value={registration.role}
                    className="w-full bg-white rounded-xl border border-D0D5DD text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div className="relative my-4 pb-8 hidden">
                <div className="w-4/12 inline-block">
                  <label
                    htmlFor="company"
                    className="leading-7 font-medium text-md text-344054"
                  >
                    Company<span className="text-D92D20">*</span>
                  </label>
                </div>
                <div className="w-8/12 inline-block">
                  <input
                    type="text"
                    id="company"
                    name="company"
                    placeholder="IDS Infotech Ltd"
                    onChange={onChange}
                    value={registration.company}
                    className="w-full bg-white rounded-xl border border-D0D5DD text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div className="relative my-4 pb-8 hidden">
                <div className="w-4/12 inline-block">
                  <label
                    htmlFor="linkedin"
                    className="leading-7 font-medium text-md text-344054"
                  >
                    Social profiles
                  </label>
                </div>
                <div className="w-8/12 inline-block">
                  <input
                    type="text"
                    id="linkedin"
                    name="linkedin"
                    onChange={onChange}
                    value={registration.linkedin}
                    placeholder="linkedin.com/company/"
                    className="w-full bg-white rounded-xl border border-D0D5DD text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div className="relative pb-8">
                <div className="md:w-4/12 w-full hidden md:inline-block"></div>
                <div className="md:w-8/12 w-full block md:inline-block">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LesC3kgAAAAADxfDRvDyxJ7-4Z4ml8i0f37NeZx"
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className="relative pb-8">
                <div className="w-4/12 inline-block"></div>
                <div className="w-8/12 inline-block">
                  <button className="inline-flex items-center bg-088AB2 border-0 py-2 px-4 focus:outline-none hover:bg-gray-200 rounded-8 text-white mt-4 md:mt-0">
                    Register Now
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="w-full">
            <h1 className="title-font text-3xl mb-4 font-semibold text-101828">
              Other Events
            </h1>
            <p className="mb-8 leading-relaxed text-md text-667085">
              The latest industry news, interviews, technologies, and resources.
            </p>
            <div className="flex flex-wrap">
              {remainingWebinar.map((web) => {
                return (
                  <div key={web.id} className="p-4 md:w-1/2">
                    <div className="h-full border-opacity-60 overflow-hidden">
                      <div className="relative hoveron">
                        <img
                          className="w-full object-cover object-center"
                          src={require("../assets/images/" +
                            web.realtedImage +
                            ".png")}
                          alt="blog"
                        />
                        <div className="absolute flex flex-row w-full bottom-0 p-8 backdrop display">
                          <p className="text-white justify-start text-sm font-normal">
                            <strong>{web.guest}</strong> <br />
                            {web.date}
                          </p>
                          <p className="text-white ml-auto text-right text-sm font-normal">
                            <strong>{web.time}</strong> <br />
                            Virtual
                          </p>
                        </div>
                      </div>
                      <div className="py-6">
                        <h1 className="title-font text-lg font-bold text-gray-900 mb-3 w-11/12">
                          {web.heading}
                        </h1>
                        <p className="leading-relaxed mb-3 text-sm">
                          {web.featuring} <br />
                          <b>{web.guest}</b>
                          <br />
                          {web.past}
                        </p>
                        <div className="flex items-center flex-wrap ">
                          <div
                            onClick={() => {
                              window.location.href = `/register/${web.heading}`;
                            }}
                            className="text-0E7090 inline-flex items-center font-medium cursor-pointer md:mb-2 lg:mb-0"
                          >
                            Watch Now
                            <Icon
                              icon="akar-icons:arrow-up-right"
                              className="inline-block"
                              color="#0E7090"
                              width="16"
                              height="16"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SingleEvent;
